import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";

const BASE = "/surat-keterangan-kelahiran";

async function masters() {
  const response = await http.getData(`${BASE}/masters`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function getByRegister(registerId: string | number) {
  const response = await http
    .getData(`/register/${registerId}/surat-keterangan-kelahiran`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function find(id: number) {
  const response = await http.getData(`${BASE}/${id}`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function create(data: any) {
  const response = await http.postData(BASE, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function update(id: number, data: any) {
  const response = await http.putData(`${BASE}/${id}`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function destroy(id: number) {
  const response = await http.deleteData(`${BASE}/${id}`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

function printPdf(id: number) {
  window.open(`${http.getAPI()}${BASE}/${id}/pdf`, "_blank");
}

export default {
  masters,
  getByRegister,
  find,
  create,
  update,
  destroy,
  printPdf
};
